module.exports = __webpack_public_path__ + "assets/img/trush.c97c2b0b.jpg";